import { IconInfoCircle } from '@tabler/icons-react';
import React from 'react';

import Tooltip from 'src/components/general/Tooltip';

const POP_IN_RECOMMENDATION_TEXT =
  'This recommendation is based on clinician credentialing, licensing, availability time, types of visit clinician has seen so far today, and other factors.';

export const PopInVisitCardHeader = () => {
  return (
    <>
      <div>
        Pop-in visit recommendation ready <span className="time">now</span>
      </div>
      <Tooltip title={POP_IN_RECOMMENDATION_TEXT} className="infoIcon">
        <IconInfoCircle />
      </Tooltip>
    </>
  );
};
